"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ProgressItem_component_exports = {};
__export(ProgressItem_component_exports, {
  ProgressItem: () => ProgressItem
});
module.exports = __toCommonJS(ProgressItem_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
var import_atoms = require("../../atoms");
var ProgressItem = function ProgressItem2(_ref) {
  var count = _ref.count, label = _ref.label, children = _ref.children;
  return /* @__PURE__ */ import_react.default.createElement(_StyledDiv, null, children, count ? /* @__PURE__ */ import_react.default.createElement(_StyledText, {
    size: "small",
    baseStyle: "text2"
  }, count) : null, /* @__PURE__ */ import_react.default.createElement(_StyledText2, {
    size: "small",
    baseStyle: "text2",
    $_css: !count && {
      "marginLeft": "0.25rem"
    }
  }, label));
};
var _StyledDiv = (0, import_styled_components.default)("div")({
  "display": "flex",
  "alignItems": "center"
});
var _StyledText = (0, import_styled_components.default)(import_atoms.Text)({
  "marginLeft": "0.25rem",
  "marginRight": "0.375rem",
  "fontWeight": "700"
});
var _StyledText2 = (0, import_styled_components.default)(import_atoms.Text).withConfig({
  displayName: "ProgressItemcomponent___StyledText2",
  componentId: "sc-1liwn7r-0"
})(["", ""], function(p) {
  return p.$_css;
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ProgressItem
});
//# sourceMappingURL=ProgressItem.component.js.map